/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { OrganizationSignupCheckResponseDataFromJSON, OrganizationSignupCheckResponseDataToJSON } from './OrganizationSignupCheckResponseData';
export function OrganizationSignupCheckResponseFromJSON(json) {
    return OrganizationSignupCheckResponseFromJSONTyped(json, false);
}
export function OrganizationSignupCheckResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        data: !exists(json, 'data') ? undefined : OrganizationSignupCheckResponseDataFromJSON(json['data'])
    };
}
export function OrganizationSignupCheckResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        data: OrganizationSignupCheckResponseDataToJSON(value.data)
    };
}
